import React from "react";

import { cn } from "../cn";

export type CheckboxProps = Omit<React.ComponentProps<"input">, "type" | "size">;

export function Checkbox({ className, ...props }: CheckboxProps) {
  return (
    <input
      type="checkbox"
      data-slot="checkbox"
      className={cn(
        // base.css supplies the checked glyph; m-0 overrides Bootstrap's checkbox offset.
        "tw-m-0 tw-size-4 tw-shrink-0 tw-appearance-none tw-rounded tw-border tw-border-solid tw-border-border tw-bg-input tw-align-middle tw-shadow-xs tw-outline-none tw-transition-[color,box-shadow]",
        "checked:tw-border-primary checked:tw-bg-primary",
        "focus-visible:tw-border-ring focus-visible:tw-ring focus-visible:tw-ring-ring/50 disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
        className,
      )}
      {...props}
    />
  );
}
